import { DeliveryInvoiceStatus } from '@/types/deliveryInvoice.types';

/** UI-facing statuses aligned with Process Service invoice */
export enum DeliveryInvoiceDisplayStatus {
  DRAFT = 'DRAFT',
  REVIEWED = 'REVIEWED',
  CONFIRMED = 'CONFIRMED',
  PAID = 'PAID',
}

export const deliveryInvoiceStatus = {
  PAID: {
    label: 'Paid',
    className: 'text-[#1B8652] bg-[#D5F4E3] hover:bg-[#D5F4E3]',
  },
  REVIEWED: {
    label: 'Reviewed',
    className: 'text-[#6C4A09] bg-[#FFEEBF] hover:bg-[#FFEEBF]',
  },
  CONFIRMED: {
    label: 'Confirmed',
    className: 'text-[#FBEDFF] bg-[#551175] hover:bg-[#551175]',
  },
  DRAFT: {
    label: 'Draft',
    className: 'text-[#0A2240] bg-[#C0CBD9] hover:bg-[#C0CBD9]',
  },
} as const;

export type DeliveryInvoiceStatusBadgeConfig =
  (typeof deliveryInvoiceStatus)[keyof typeof deliveryInvoiceStatus];

export const mapApiStatusToDisplay = (
  apiStatus: DeliveryInvoiceStatus | string | undefined
): DeliveryInvoiceDisplayStatus => {
  switch (apiStatus) {
    case DeliveryInvoiceStatus.PENDING:
      return DeliveryInvoiceDisplayStatus.REVIEWED;
    case DeliveryInvoiceStatus.CONFIRMED:
      return DeliveryInvoiceDisplayStatus.CONFIRMED;
    case DeliveryInvoiceStatus.PAID:
      return DeliveryInvoiceDisplayStatus.PAID;
    case DeliveryInvoiceStatus.DRAFT:
      return DeliveryInvoiceDisplayStatus.DRAFT;
    default:
      return DeliveryInvoiceDisplayStatus.DRAFT;
  }
};

export const mapDisplayStatusToApi = (
  displayStatus: DeliveryInvoiceDisplayStatus
): DeliveryInvoiceStatus => {
  switch (displayStatus) {
    case DeliveryInvoiceDisplayStatus.REVIEWED:
      return DeliveryInvoiceStatus.PENDING;
    case DeliveryInvoiceDisplayStatus.CONFIRMED:
      return DeliveryInvoiceStatus.CONFIRMED;
    case DeliveryInvoiceDisplayStatus.PAID:
      return DeliveryInvoiceStatus.PAID;
    case DeliveryInvoiceDisplayStatus.DRAFT:
      return DeliveryInvoiceStatus.DRAFT;
    default:
      return DeliveryInvoiceStatus.PENDING;
  }
};

export const getDeliveryInvoiceStatusBadge = (
  apiStatus: DeliveryInvoiceStatus | string | undefined
): DeliveryInvoiceStatusBadgeConfig => {
  const displayStatus = mapApiStatusToDisplay(apiStatus);
  return deliveryInvoiceStatus[displayStatus];
};
